export const navigationHierarchyItemNoDndKey = {
  "data-no-dnd": true,
};
